export default "__VITE_ASSET__C6Y2tX5q__"